import React from "react";
import {
    Box,
    Heading,
    Input,
    InputGroup,
    InputRightElement,
    Flex,
    Spacer,
    Checkbox,
    Select
} from "@chakra-ui/react";
import CustomButton from "../../elements/customButton";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { preventInvalidKey, validateAlphaNumeric } from '../../../utilities/CustomFunctions';

export default function KycLoanDetails({
    inputValues,
    userData,
    handleChange,
    panData,
    handleVerifyPan,
    handleBusinessAddress,
    checkBusinessAddress,
    gstData,
    dropdownData
}) 
{
  const gstParsedat =userData?.gst_detail?.authorised_signatory ? JSON.parse(userData?.gst_detail?.authorised_signatory) :""
  const gstParsedata =gstData?.authorised_signatory ? JSON.parse(gstData?.authorised_signatory) :""
  return (
        <>
          {(userData?.employment_type === '4' || userData?.employment_type === '5' ||  userData?.employment_type === '6'  || userData?.employment_type === '7' || userData?.employment_type === '8'  || userData?.employment_type === '10' ||  userData?.employment_type === '9') &&
                        <Box mt={7} className='form_kyc'>
                          {
                             (userData?.employment_type == '6' || userData?.employment_type == '9') ?
                             <Heading as="h1" className="font-poppins label_heading" mb={3}>GST Number (Optional)</Heading>
                            :
                        <Heading as="h1" className="font-poppins label_heading" mb={3}>GST Number</Heading>

                          }
                        <Input
                          type="text"
                          placeholder="Please Enter Your GST Number"
                          name="gst"
                          variant="filled"
                          onChange={handleChange}
                          className="input_box_select font-poppins bg_white"
                          value={inputValues?.gst ??  userData?.gst_detail?.gstin ?? ''}
                          isReadOnly={userData?.gst_detail?.gstin || gstData}
                        >
                        </Input>
                        {
                          (userData?.employment_type === "8" ||  userData?.employment_type === "9" || userData?.employment_type === "10") &&
                          <>
                       <Box className='verified_data'>
                      <Heading as="p" className='font-poppins'><b>Company Name:</b>
                        {' '}{ gstData?.legal_name ?? userData?.gst_detail?.legal_name}
                      </Heading>
                       <Heading as="p" className='font-poppins'><b>Registeration Date:</b> 
                       
                        {gstData?.registration_date ?? userData?.gst_detail?.registration_date}
                      </Heading>
                       <Heading as="p" className='font-poppins'><b>Status:</b> 
                       {
                        gstData?.status ?? userData?.gst_detail?.status
                       }
                      </Heading>
                    </Box>
                      
                    </>  

                        }
                      
                        </Box>
                      
                }
              {(userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '7' || userData?.employment_type === '8' || userData?.employment_type === '10' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                <>
                {
                  userData?.employment_type === '8'  &&
                  <Box  mt={7} className='form_kyc'>
                  <Heading as="h1" className='font-poppins label_heading' mb={3}>Business Sector</Heading>
                  <Select placeholder="Please Select Business Sector" variant="filled" className="font-poppins input_box_select"
                      name="company_buss_sector" onChange={handleChange} value={userData?.personal_data?.company_buss_sector ?? inputValues?.company_buss_sector  ?? ''}>
                      {dropdownData?.company_sector.map((item, index) => {
                          return (
                              <option key={index} value={item.key}>{item.value}</option>
                          )
                      })}
                  </Select>
              </Box>
                }
                
                 
                  <Box mt={7} className='form_kyc'>
                    {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Register Address</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm Register Address</Heading>
                    }
                    {
                      (userData?.employment_type == "8" ||  userData?.employment_type == "10" || userData?.employment_type === '6' || userData?.employment_type === '9')  ?
                      <Input
                      type="text"
                      placeholder="Please Enter Your Register Address"
                      name="registered_address"
                      variant=""
                      onChange={handleChange}
                      className="input_box_select font-poppins bg_white"
                      value={gstData?.registered_address ??  userData?.gst_detail?.registered_address ??  inputValues?.registered_address ?? userData?.personal_data?.company_reg_address  ??''}
                    >
                    </Input>
                     :
                     <Input
                      type="text"
                      placeholder="Please Enter Your Register Address"
                      name="company_reg_address"
                      variant=""
                      onChange={handleChange}
                      className="input_box_select font-poppins bg_white"
                      value={ userData?.personal_data?.company_reg_address  ?? inputValues?.company_reg_address ?? ''}
                    >
                    </Input>
                    }
                    
                  </Box>
                  <Flex mt={7} className='col-gap form_kyc'>
                    <Box className='w-100'>
                      {/* <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Register Pincode</Heading> */}
                      {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Register Pincode</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm Register Pincode</Heading>
                    }
                    {
                       (userData?.employment_type == "8" ||   userData?.employment_type == "10"  || userData?.employment_type === '9') ?
                       <Input
                       type="number"
                       size="md"
                       name="pincode"
                      //  name={userData?.employment_type === '9' ? "company_reg_pincode":}
                       placeholder="Enter Pin Code"
                       onChange={handleChange}
                       className="input_box font-poppins bg_white"
                       value={inputValues?.pincode ?? gstData?.pincode ?? userData?.gst_detail?.pincode ?? userData?.personal_data?.company_reg_pincode ??  ''}
                       onKeyDown={preventInvalidKey}
                     disabled={(gstData?.state || userData?.gst_detail?.pincode ) ? true:false}
                     />
                     :
                     <Input
                     type="number"
                     size="md"
                     name="company_reg_pincode"
                     placeholder="Enter Pin Code"
                     onChange={handleChange}
                     className="input_box font-poppins bg_white"
                     value={inputValues?.company_reg_pincode ?? userData?.personal_data?.company_reg_pincode ?? ''}
                     onKeyDown={preventInvalidKey}
                   />
                    }
                     
                    </Box>
                    <Spacer />
                    <Box className='w-100'>
                      {/* <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Register  State</Heading> */}
                      {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Register State</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm Register State</Heading>
                    }
                    {
                      (userData?.employment_type === '8' || userData?.employment_type === '10' || userData?.employment_type === '9') ?
                      <Input
                      type="text"
                      size="md"
                      name="state"
                      // isReadOnly={true}
                      placeholder="Enter State"
                      onChange={handleChange}
                      disabled={(gstData?.state || userData?.gst_detail?.state)?true:false}
                      className="input_box font-poppins bg_white"
                      value={inputValues?.state ?? gstData?.state ?? userData?.gst_detail?.state ?? userData?.personal_data?.company_reg_state ?? ''}
                    />
                    :
                    <Input
                    type="text"
                    size="md"
                    name="company_reg_state"
                    isReadOnly={true}
                    placeholder="Enter State"
                    onChange={handleChange}
                    className="input_box font-poppins bg_white"
                    value={inputValues?.company_reg_state ?? userData?.personal_data?.company_reg_state ?? ''}
                  />
                    }
                     
                    </Box>
                  </Flex>
                  <Box mt={7}>
                    <Box className="checkbox_item" >
                      {
                        (userData?.employment_type === '4' || userData?.employment_type === '5'  || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') && 
                        <Checkbox onChange={(e) => handleBusinessAddress(e)} isChecked={checkBusinessAddress}>
                        My Company Register Address is same as My Company Business Address
                        { (userData?.employment_type == "9" || userData?.employment_type == "6") && <span style={{fontWeight:"700"}}> (Optional)</span>}
                      </Checkbox>
                     }
                      {
                        (userData?.employment_type === '7'|| userData?.employment_type === '10') && 
                        <Checkbox onChange={(e) => handleBusinessAddress(e)} isChecked={checkBusinessAddress}>
                        My Firm Address is same as My  Business Address
                      </Checkbox>
                     }
                      
                    </Box>
                    {!checkBusinessAddress ?
                    <>
                      <Box mt={5} className='form_kyc'>
                        {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Business Address</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm  Business Address</Heading>
                    }
                        <Input
                          type="text"
                          placeholder="Please Enter  Your Business Address"
                          name="company_buss_address"
                          variant=""
                          onChange={handleChange}
                          className="input_box_select font-poppins bg_white"
                          value={inputValues?.company_buss_address ?? userData?.personal_data?.company_buss_address ?? ''}
                        />
                      </Box>
                      <Flex mt={5} className='col-gap form_kyc'>
                        <Box className='w-100'>
                          {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Business Pincode</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm  Business Pincode</Heading>
                    }
                          <Input
                            type="text"
                            size="md"
                            name="company_buss_pincode"
                            placeholder="Enter Pin Code"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.company_buss_pincode ?? userData?.personal_data?.company_buss_pincode ?? ''}
                            onKeyDown={preventInvalidKey}
                          />
                        </Box>
                        <Spacer />
                        <Box className='w-100'>
                          {
                      (userData?.employment_type === '4' || userData?.employment_type === '5' || userData?.employment_type === '8' || userData?.employment_type === '6' || userData?.employment_type === '9') ?
                      <Heading as="h1" className="font-poppins label_heading" mb={3}>Company Business State</Heading>
                    :   
                    <Heading as="h1" className="font-poppins label_heading" mb={3}>Firm  Business State</Heading>
                    }
                          <Input
                            type="text"
                            size="md"
                            name="company_buss_state"
                            isReadOnly={true}
                            placeholder="Enter State"
                            onChange={handleChange}
                            className="input_box font-poppins bg_white"
                            value={inputValues?.company_buss_state ?? userData?.personal_data?.company_buss_state ?? ''}
                          />
                        </Box>
                      </Flex>
                    </> : null}
                  </Box>
                </> : null 
              }
        </>
    );
}
